import { PageRouteBuilder } from "@common/route/page-route-builder";
import { LoginExternalPageComponent } from "./login-external-page.component";

export const loginExternalPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-login-external-page", LoginExternalPageComponent)
    .atUrl("/account/external-login")
    .requiresLogin(false)
    .requiresAnonymous(false)
    .build();
